import { ExclamationCircle } from '@squareup/dex-icons/market/alert';
import { Box, Paragraph20 } from '@squareup/dex-ui-shared-base';
import { MarketLink } from '@squareup/dex-ui-shared-market';
import React, { FC } from 'react';

import styles from './expired-token-warning.module.css';

const strings = {
  expiredAuth: 'This token is expired.',
  renewAuth: 'Renew now',
};

type Props = {
  isLoading: boolean;
  onShowDialog(): void;
};

const ExpiredTokenMessage: FC<Props> = ({ isLoading, onShowDialog }) => {
  return (
    <Box className={styles['expired-message']} margin={{ top: '1x' }}>
      <ExclamationCircle className={styles['icon-warning']} />
      <Paragraph20>{strings['expiredAuth']}</Paragraph20>
      <Paragraph20>
        <MarketLink
          aria-haspopup="dialog"
          className={styles['renew-link'] as string}
          onClick={onShowDialog}
          role="button"
          trackingId="renew-sandbox-auth-action"
          disabled={isLoading}
        >
          {strings['renewAuth']}
        </MarketLink>
      </Paragraph20>
    </Box>
  );
};

export { ExpiredTokenMessage };
